import service from "./service";
import {getEndpoints} from "../helpers";

export const getCredentialInfo = ()=>{
    return service.extGet(getEndpoints.mekarBaseUrl + "api/users/social-credential/")
}

